import React from "react";
import PrintSafesMain from "../PrintSafesMain";

export default function RevGardUnitts(props) {
    return (
        <div>
            <PrintSafesMain  typePrint={2} docNamePdf={"RevewJard.pdf"} docName={"RevewJard"}/>
        </div>
    );
}

